<script setup>
const emit = defineEmits(['actionClicked']);
const props = defineProps({
  actions: {
    type: Array,
    required: true
  },
  initialHidden: {
    type: Boolean,
    default: true
  }
});

function onClick(event, action) {
  event.preventDefault();
  emit('actionClicked', action);
}

</script>

<template>
  <aside class="inline-actions" v-bind:class="{'inline-actions--inital-hidden': props.initialHidden}">
    <ul class="inline-actions__items">
      <li 
        class="inline-actions__item" 
        v-for="(action, index) in props.actions" 
        v-bind:key="`action-${index}`">
          <UiButton 
            v-bind:icon-only="true" 
            size="minor" 
            v-bind:icon="action.icon" 
            type="text"
            v-on:click="onClick($event, action)">
          </UiButton>
      </li>
    </ul>
  </aside>
</template>

<style lang="scss">
.inline-actions__items {
  display: flex;
  justify-content: flex-end;
  list-style: none;
  overflow: hidden;
}

.inline-actions--inital-hidden {
  .inline-actions__item {
    transform: translateY(-100%);
    transition: transform 200ms;
  }

  @for $i from 1 through 9 {
    .inline-actions__item:nth-child(#{$i}) {
      transition-delay: $i * 30ms;
    }
  }
}

.actions-hover-trigger:hover .inline-actions__item {
  transform: translateY(0);
}
</style>
